import { Currency } from "./currency";
import { i18n } from "@lingui/core";
import { formatI18nCurrency as originalFormatI18nCurrency } from "@silversea-ssc/system-components-react/utils";

export const formatI18nCurrency = (
  value: number,
  currency: Currency | undefined,
  currentCurrency?: Currency
): string =>
  originalFormatI18nCurrency(value, currency, i18n.locale, currentCurrency);
